<template>
    <AppLayoutBase>
        <template slot="drawer">
            <AppLayoutNavbarDrawer title="WerkBank">
                <template slot="img">
                    <img src="@/assets/ideas-workbench-primary.svg" alt="WerkBank"/>
                </template>
                <template slot="list">
                    <IdeasWorkbenchLayoutDrawer/>
                </template>
            </AppLayoutNavbarDrawer>
        </template>

        <template slot="main">
            <IdeasWorkbenchIdeasCreateContent/>
        </template>
    </AppLayoutBase>
</template>

<script>
    export default {
        name: ""
    }
</script>

<style scoped>

</style>